import { OnboardingLayout } from '@forwardflow/layouts/OnboardingLayout'
import { OnboardingSteps } from '@forwardflow/modules/onboarding'
import { SaveConflictBanner } from '@forwardflow/modules/onboarding'

export default function OnboardingPage() {
   return (
      <OnboardingLayout>
         {/* Plan 261 — says so when this tab has stopped saving. */}
         <SaveConflictBanner />
         <OnboardingSteps />
      </OnboardingLayout>
   )
}
